// --------------------------------------------------------------------------
// datePicker.js
// --------------------------------------------------------------------------
// Reads in JSON of months and their available dates, then builds into handlebars template
// --------------------------------------------------------------------------

RN.datePicker = function() {

  'use strict';

  var template,
      forceDate, 
      bookingType, 
      slider,
      type;

  var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  function init() {
    template = $('#date-picker');
    forceDate = $('#forceDate');
    bookingType = $('#bookingType');

    slider = byBehaviour('date-pickers-slider');
    type = slider.data('type')

    if (template.length !== 0) {
        var url = '/performances/available_days'
        if (type === 'timed-ticketing') {
            url = '/api/tickets/step-1?bookingType=' + ((bookingType.length) ? bookingType.val() : "") + '&forceDate=' + ((forceDate.length) ? forceDate.val() : "")
        }
      fetchAvailabilityData(url);
    }

  }

  function fetchAvailabilityData(url) {
    $.ajax({
      url : url,
      method: 'GET',
      success : handleResponse
    });
  }

  function handleResponse(data){
    var template = $('#date-picker').html()
    var view = Handlebars.compile(template)

    data.data.forEach(function(month) {
      var dataMonth = {
        month: month.month,
        firstDay : month.first_day,
        days: [],
      },
      output;

      for (var i = 1; i <= month.days; i++) {
        var date = new Date(i + ' ' + month.month),
            dateYear = date.getFullYear(),
            dateMonth = date.getMonth() + 1,
            displayDay,
            displayMonth, 
            day;

        if(i < 10){
            displayDay = '0' + i;
        }
        else{
            displayDay = i;
        }

        displayMonth = dateMonth;
        if (displayMonth < 10) {
          displayMonth = '0' + displayMonth;
        }

        day = {
          dayOfMonth : i,
          longDate: dateYear + '-' + displayMonth + '-' + displayDay,
          prettyDate: monthNames[date.getMonth()] + ' ' + displayDay + ', ' + dateYear
        }

        if (month.available_days.indexOf(i) > -1) {
          day.performanceId = month.performance_ids[month.available_days.indexOf(i)];
          day.available = true;
        } else {
          day.available = false;
        }

        if(i === month.checked_day){
          day.checked = true;
        }

        dataMonth.days.push(day);
      }

      output = view(dataMonth);
      slider.append(output);
    });
    startSlider();
    RN.enableSubmit.init();
    RN.enableTicketDetails.init();
    RN.updateExhibitsDate.init(); 
    
    // Get current date to find input
    var d = new Date();
    var month = d.getMonth()+1;
    var day = d.getDate();
    var currentDate = d.getFullYear() + '-' +
    (month<10 ? '0' : '') + month + '-' +
    (day<10 ? '0' : '') + day;
    var currentDateInput = $(':input').filter('#date-select-' + currentDate)
    // currentDateInput.prop('checked', false)
    currentDateInput.addClass('date-picker__input--current-date')
  }

  function startSlider() {
    var slides = slider.data('slides') || 1;
    slider.slick({
      variableWidth: true,
      slidesToShow: slides,
      slidesToScroll: slides,
      infinite: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 930,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  return {
    init: init
  };

}();
